export default __webpack_public_path__ + "static/media/arrow-down-icon.fea416e3.svg";